import { createContext, useState } from "react";

const VocReportContext = createContext({});

export const VocReportProvider = ({ children }) => {
  const [tabs, setTabs] = useState("current");

  return (
    <VocReportContext.Provider value={{ tabs, setTabs }}>
      {children}
    </VocReportContext.Provider>
  );
};

export default VocReportContext;
